module.exports = __webpack_public_path__ + "static/media/search.ae57318b.svg";